import { get, has, debounce, delay } from 'lodash';
import versionData from '../version.json';

export const isNativeWrapper = () => has(window, 'AppInstall');

class MessageQueue {
  constructor() {
    this.queue = [];
    this.ready = false;
    this.sendDebounced = debounce(() => this.handleSend());

    delay(() => {
      this.ready = true;
      this.sendDebounced();
    }, 200);
  }

  handleSend() {
    if (!this.ready) {
      return;
    }

    const message = this.queue.shift();

    if (!message) {
      return;
    }

    const { msg, resolve } = message;

    window.postMessage(msg, window.location.origin);
    resolve();

    if (this.queue.length) {
      this.sendDebounced();
    }
  }

  send(msg, resolve) {
    this.queue.push({ msg, resolve });
    this.sendDebounced();
  }
}

const queue = new MessageQueue();

export const sendCommand = (cmd, payload) =>
  new Promise(resolve => queue.send(JSON.stringify({ cmd, payload }), resolve));

export const getPlatform = () => {
  if (/\[GEMS UI - ACCESS ios]/.test(window.navigator.userAgent)) {
    return 'ios';
  }

  if (/\[GEMS UI - ACCESS android]/.test(window.navigator.userAgent)) {
    return 'android';
  }

  return 'web';
};

export const parseAppVersion = () => {
  const userAgent = get(window, 'navigator.userAgent');
  const versionParser = /\[GEMS UI - ACCESS \w+] v(.+) \((.+)\)$/;

  if (!versionParser.test(userAgent)) {
    return null;
  }

  const [, appVersion, buildNumber] = versionParser.exec(userAgent);
  return { appVersion, buildNumber };
};

export const versionCompare = (l, r) => {
  const ln = l.split('.');
  const rn = r.split('.');
  const len = Math.max(ln.length, rn.length);

  for (let i = 0; i < len; i += 1) {
    const lv = parseInt(get(ln, i, 0), 10);
    const rv = parseInt(get(rn, i, 0), 10);

    const result = lv - rv;

    if (result !== 0) {
      return result;
    }
  }

  return 0;
};

export const ensureJSInjected = new Promise((resolve) => {
  const appVersion = get(parseAppVersion(), 'appVersion');
  const alreadyInjected = has(window, '_features');

  // In case of old wrapper
  if (alreadyInjected || !appVersion || versionCompare(appVersion, '2.8') < 0) {
    resolve();
    return;
  }

  const crashTimer = setTimeout(() => {
    sendCommand('fatal', `JS injection not resolved in 10sec (${appVersion})`);
  }, 10000);

  window.injectResolver = () => {
    clearTimeout(crashTimer);
    resolve();
  };
});

export const isDevice = () =>
  getPlatform() !== 'web';

export const getAppVersion = () => {
  let appVersion = '';
  if (window.AppInstall) {
    appVersion = `Mobile ${window.AppInstall.info.appVersion}`;
  }

  return appVersion;
};

export const hasChatSupport = () =>
  get(window, '_features.chat', false);

export const getOAuthApplicationId = () =>
  get(window, '_config.oauthApplicationId', false);

export const uiVersion = versionData.version;



// WEBPACK FOOTER //
// ./src/utils/mobile.js